import * as React from 'react';
import l10n = require('diy/util/l10n');
import IconTextButton from "diy/custom-components/icon-text-button/IconTextButton";
import {ToolbarGroup} from './toolbar/ToolbarGroup';
import {ToolbarContent} from './toolbar/ToolbarContent';
import {Dropdown} from './toolbar/Dropdown';
import {Divider} from './toolbar/Divider';
import AddBoxIcon from 'material-ui/svg-icons/content/add-box';
import {ColumnSettings} from "./common/ColumnSettings";
import ViewColumn from 'material-ui/svg-icons/action/view-column';
import {Messages} from './common/Messages';
import {ConnectedAviary} from './aviary/ConnectedAviary';

export interface StateProps {
    canAddGroup: boolean;
    canManageColumns: boolean;
    numberOfColumns: number;
    availableNumberOfColumns: number[];
    columnFitMode: number;
    isAddGroupAvailable: boolean;
}

export interface DispatchProps {
    onAddGroup: () => void;
    onChangeColumnNumber: (value: number) => void;
    onChangeColumnFitMode: (fitMode: number) => void;
}

interface GroupsViewProps extends StateProps, DispatchProps {

}

export class GroupsView extends React.Component<GroupsViewProps, {}> {
    render() {
        return (
            <div>
                <ToolbarContent>
                    <ToolbarGroup>
                        <IconTextButton
                            style={{marginRight: 12}}
                            text={l10n.getString('section.actionBar.buttons.addGroup.label')}
                            Icon={<AddBoxIcon/>}
                            onTouchTap={() => this.props.onAddGroup()}
                            useAlternativeColors={true}
                            dataTestId="section-add-group-button"
                            isDisabled={!this.props.canAddGroup}
                        />
                        <Divider />
                        <Dropdown
                            text={l10n.getString('section.columnSettings.title')}
                            Icon={<ViewColumn/>}
                            disabled={!this.props.canManageColumns}
                            layerStyle={{
                                marginTop: 7,
                                padding: 0,
                                minWidth: 180
                            }}
                            dataTestId="section-manage-columns"
                        >
                            <ColumnSettings
                                activeColumn={this.props.numberOfColumns}
                                fitMode={this.props.columnFitMode}
                                availableColumns={this.props.availableNumberOfColumns}
                                onColumnNumberSelected={this.props.onChangeColumnNumber}
                                onFitModeChanged={this.props.onChangeColumnFitMode}
                            />
                        </Dropdown>
                    </ToolbarGroup>
                </ToolbarContent>
                <Messages showAddGroup={this.props.isAddGroupAvailable && !this.props.canAddGroup} />
                <ConnectedAviary />
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/GroupsView.tsx
 **/